import { renderSite } from "ccui-framework";
import { combineReducers } from "./combineReducers";
import { configModule } from "./config";
import { App } from "./Appv2";

import "react-virtualized/styles.css";
import "./tailwind.generated.css";

import "./styles/premier/all.scss";

const config = configModule();

renderSite(config, combineReducers, App);
